const filters = (state = {}, action) => {
  switch (action.type) {
  case 'SET_FILTER_DATA':
    return action.payload;
  case 'ADD_FILTER_DATA':
    return { ...state, [action.payload.type]: action.payload.data };
  default:
    return state;
  }
};

export default filters;
